import _Header from '../_app/cuchillo/layout/Header';
import { Power3 } from "gsap";
import Sidemenu from './Sidemenu';

export default class Header extends _Header {

  static isFixed = true;

  static options = {
    show: {
      duration: .3,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static directHide () {
    this.container.style.opacity = 0;
  }

  static directShow () {
    this.container.style.opacity = 1;
  }
}


